import _ from 'lodash';
import {
  IconAnalyze,
  IconChartHistogram,
  IconManualGearbox,
  IconFlask,
  IconDeviceAnalytics,
  IconWheel,
  IconMapQuestion,
  IconDeviceImacStar,
  IconEngineFilled,
  IconBulbFilled,
  IconUsersGroup,
} from '@tabler/icons-react';
import Landing from 'views/Landing';
import QuickView from 'views/quickview/Page';
import Users from 'views/Users';
import Analyzers from 'views/Analyzers';
import AnalyzersPA from 'views/AnalyzersPA';
import AssetDiscovery from 'views/AssetDiscovery';
import RiskGuide from 'views/RiskGuide';
import AdvancedAnalytics from 'views/advanced-analytics/Base';
import InvestmentAnalysis from 'views/investment-analysis/Base';
import InvestmentComparison from 'views/investment-comparison/Base';
import ClientPortfolio from 'views/my-flare/ClientPortfolio';
import ModelPortfolios from 'views/my-flare/ModelPortfolios';
import AlternativeDashboard from 'views/my-flare/AlternativeDashboard';
import ImportData from 'views/my-flare/ImportData';
import AlignedUma from 'views/my-flare/AlignedUma';
import AssetClasses from 'views/my-flare/AssetClasses';
import BuildPortfolio from 'views/portfolio-analysis/BuildPortfolio';
import PortfolioAnalysisSingleAdvanced from 'views/portfolio-analysis/single/advanced/Base';
import PortfolioAnalysisSingleAnalyze from 'views/portfolio-analysis/single/analyze/Base';
import PortfolioAnalysisMultipleAdvanced from 'views/portfolio-analysis/multiple/advanced/Base';
import PortfolioAnalysisMultipleAnalyze from 'views/portfolio-analysis/multiple/analyze/Base';
import PortfolioAnalysisOptimizationBuild from 'views/portfolio-analysis/optimization/build/Page';
import PortfolioAnalysisOptimizationResult from 'views/portfolio-analysis/optimization/result/Page';

import { meta as chartsMeta } from 'views/charts/Landing';
import { meta as correlationMeta } from 'views/correlation/Landing';
import { meta as insightToolboxMeta } from 'views/insights-toolbox/Landing';
import { meta as performanceEngineMeta } from 'views/performance-engine/Landing';
import { meta as riskLabMeta } from 'views/risk-lab/Landing';
import { meta as userGuideMeta } from 'views/user-guide/Landing';

function landingMetaToRoutes(meta, iconClassName, icon) {
  const result = [];

  result.push({
    collapse: false,
    name: meta.title,
    icon,
    iconClassName,
    path: meta.path,
    component: meta.component,
    layout: '',
    permissions: _.uniq(meta.items.map((item) => item.permission)),
  });

  for (let x = 0; x < meta.items.length; x++) {
    const item = meta.items[x];
    result.push({
      path: `${meta.path}${item.path}`,
      name: item.title,
      component: item.component,
      layout: '',
      permission: item.permission,
      redirect: true,
    });
  }

  return result;
}

const routes = [
  {
    path: '/landing',
    name: 'Introducing FLARE™',
    icon: <IconAnalyze size={24} className="" />,
    component: Landing,
    layout: '',
    redirect: true,
    titleBold: true,
  },
  ...landingMetaToRoutes(userGuideMeta, '', <IconMapQuestion size={24} className="" />),
  {
    path: '/qv',
    name: 'Quick View',
    icon: <IconDeviceAnalytics size={24} className="" />,
    component: QuickView,
    layout: '',
    permission: 'qv',
  },
  {
    path: '/analyzers',
    name: 'FLARE™ Analyzers',
    icon: <IconManualGearbox size={24} className="" />,
    component: Analyzers,
    layout: '',
    permission: 'az',
  },
  {
    collapse: true,
    name: 'MY FLARE™',
    icon: <IconDeviceImacStar size={24} className="" />,
    state: 'pagesCollapse',
    permission: 'mf',
    views: [
      {
        path: '/mf/model-portfolios',
        name: 'Model Portfolios',
        mini: 'MP',
        component: ModelPortfolios,
        layout: '',
        permission: 'mf-model-portfolios',
      },
      {
        path: '/mf/aligned-uma',
        name: 'A360 | Aligned ONE',
        mini: 'AU',
        component: AlignedUma,
        layout: '',
        permission: 'mf-aligned-uma',
      },
      {
        path: '/mf/asset-classes',
        name: 'Asset Classes',
        mini: 'AC',
        component: AssetClasses,
        layout: '',
        permission: 'mf-asset-classes',
      },
      {
        path: '/mf/alternative-funds',
        name: 'Alternative Funds',
        mini: 'AF',
        component: AlternativeDashboard,
        layout: '',
        permission: 'mf-alternative-funds',
      },
      {
        path: '/mf/import-data',
        name: 'Import My Data',
        mini: 'ID',
        component: ImportData,
        layout: '',
        permission: 'mf-import-data',
      },
    ],
  },
  ...landingMetaToRoutes(performanceEngineMeta, '', <IconEngineFilled size={24} className="" />),
  ...landingMetaToRoutes(riskLabMeta, '', <IconFlask size={24} className="" />),
  ...landingMetaToRoutes(correlationMeta, '', <IconWheel size={24} className="" />),
  ...landingMetaToRoutes(insightToolboxMeta, '', <IconBulbFilled size={24} className="" />),
  ...landingMetaToRoutes(chartsMeta, '', <IconChartHistogram size={24} className="" />),
  {
    path: '/aa',
    name: 'Advanced Analytics',
    icon: <IconAnalyze size={24} className="" />,
    component: AssetDiscovery,
    layout: '',
    permission: 'aa',
  },
  {
    path: '/aa/result',
    name: 'Advanced Analytics',
    icon: <IconAnalyze size={24} className="" />,
    component: AdvancedAnalytics,
    layout: '',
    redirect: true,
    permission: 'aa',
  },
  {
    collapse: true,
    path: '/um',
    name: 'User Management',
    icon: <IconUsersGroup size={24} className="" />,
    state: 'userMenuCollapse',
    permission: 'um',
    views: [
      {
        path: '/um/assigned-users',
        name: 'Assigned Users',
        mini: 'CP',
        component: Users,
        layout: '',
        permission: 'um',
        state: 'assigned',
      },
      {
        path: '/um/pending-users',
        name: 'Pending Users',
        mini: 'CP',
        component: Users,
        layout: '',
        permission: 'um',
        state: 'pending',
      },
    ],
  },
  {
    path: '/pa',
    name: 'Portfolio Engineer',
    component: AnalyzersPA,
    layout: '',
    // permission: 'analyzers',
    redirect: true,
  },
  {
    path: '/ia',
    name: 'Investment Analysis',
    icon: <IconAnalyze size={24} className="" />,
    component: AssetDiscovery,
    layout: '',
    redirect: true,
    permission: 'ia',
  },
  {
    path: '/ia/result',
    name: 'Investment Analysis',
    icon: <IconAnalyze size={24} className="" />,
    component: InvestmentAnalysis,
    layout: '',
    redirect: true,
    permission: 'ia',
  },
  {
    path: '/ic',
    name: 'Investment Comparison',
    icon: <IconAnalyze size={24} className="" />,
    component: AssetDiscovery,
    layout: '',
    redirect: true,
    permission: 'ic',
  },
  {
    path: '/ic/result',
    name: 'Investment Comparison',
    icon: <IconAnalyze size={24} className="" />,
    component: InvestmentComparison,
    layout: '',
    redirect: true,
    permission: 'ic',
  },
  {
    path: '/pa/build',
    name: 'Build Portfolio',
    icon: <IconAnalyze size={24} className="" />,
    component: BuildPortfolio,
    redirect: true,
    layout: '',
    permission: 'pa-build',
  },
  {
    path: '/pa/build/result',
    name: 'Portfolio Engineer',
    icon: <IconAnalyze size={24} className="" />,
    component: PortfolioAnalysisSingleAnalyze,
    redirect: true,
    layout: '',
    permission: 'pa-build-result',
  },
  {
    path: '/pa/build/advanced',
    name: 'Portfolio Engineer',
    icon: <IconAnalyze size={24} className="" />,
    component: PortfolioAnalysisSingleAdvanced,
    redirect: true,
    layout: '',
    permission: 'pa-build-advanced',
  },
  {
    path: '/pa/compare',
    name: 'Compare Portfolios',
    icon: <IconAnalyze size={24} className="" />,
    component: BuildPortfolio,
    redirect: true,
    layout: '',
    permission: 'pa-compare',
  },
  {
    path: '/pa/compare/result',
    name: 'Portfolio Analysis',
    icon: <IconAnalyze size={24} className="" />,
    component: PortfolioAnalysisMultipleAnalyze,
    redirect: true,
    layout: '',
    permission: 'pa-compare-result',
  },
  {
    path: '/pa/compare/advanced',
    name: 'Portfolio Analysis',
    icon: <IconAnalyze size={24} className="" />,
    component: PortfolioAnalysisMultipleAdvanced,
    redirect: true,
    layout: '',
    permission: 'pa-compare-advanced',
  },
  {
    path: '/pa/portfolio-optimization',
    name: 'Portfolio Optimization',
    icon: <IconAnalyze size={24} className="" />,
    component: PortfolioAnalysisOptimizationBuild,
    redirect: true,
    layout: '',
    permission: 'pa-portfolio-optimization',
  },
  {
    path: '/pa/portfolio-optimization/result',
    name: 'Portfolio Optimization',
    icon: <IconAnalyze size={24} className="" />,
    component: PortfolioAnalysisOptimizationResult,
    redirect: true,
    layout: '',
    permission: 'pa-portfolio-optimization',
  },
  {
    path: '/rg',
    name: 'Risk Guide',
    icon: <IconMapQuestion size={24} className="" />,
    component: RiskGuide,
    layout: '',
    permission: 'rg',
  },
];

export default routes;
